// Actions
export const API_RESPONSE_SUCCESS = 'API_RESPONSE_SUCCESS';
export const API_RESPONSE_ERROR = 'API_RESPONSE_ERROR';
export const GET_OVERVIEW = 'GET_OVERVIEW';
export const GET_PROPOSALS_BY_PLANS = 'GET_PROPOSALS_BY_PLANS';
export const GET_DEMOGRAPHIC_DATA = 'GET_DEMOGRAPHIC_DATA';
export const GET_OVERVIEW_MAPS_DATA = 'GET_OVERVIEW_MAPS_DATA';
export const GET_OVERVIEW_SALES_FORECAST = 'GET_OVERVIEW_SALES_FORECAST';
export const GET_PROPOSALS_SITUATION = 'GET_PROPOSALS_SITUATION';
